let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5x3QX")).then(() => parcelRequire('2trcY'));